import { c as _c } from "react/compiler-runtime";
const YoutubeIcon = props => {
  const $ = _c(3);
  const {
    className
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M11.429 8q0-0.33-0.268-0.482l-4.571-2.857q-0.277-0.179-0.58-0.018-0.295 0.161-0.295 0.5v5.714q0 0.339 0.295 0.5 0.143 0.071 0.277 0.071 0.179 0 0.304-0.089l4.571-2.857q0.268-0.152 0.268-0.482zM16 8q0 0.857-0.009 1.339t-0.076 1.219-0.201 1.317q-0.143 0.652-0.616 1.098t-1.107 0.518q-1.982 0.223-5.991 0.223t-5.991-0.223q-0.634-0.071-1.112-0.518t-0.621-1.098q-0.125-0.58-0.192-1.317t-0.076-1.219-0.009-1.339 0.009-1.339 0.076-1.219 0.201-1.317q0.143-0.652 0.616-1.098t1.107-0.518q1.982-0.223 5.991-0.223t5.991 0.223q0.634 0.071 1.112 0.518t0.621 1.098q0.125 0.58 0.192 1.317t0.076 1.219 0.009 1.339z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== className) {
    t1 = <svg className={className} fill="currentColor" width="100%" height="100%" viewBox="0 0 16 16">{t0}</svg>;
    $[1] = className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default YoutubeIcon;